import {OfferType} from "../types/OfferType";
import {PropertyFlatType} from "../types/PropertyFlatType";

interface IProps {
    offerType?: OfferType;
    flatType?: PropertyFlatType;
    isHolidayLocation?: boolean;
    isCondoHotel?: boolean;
    fallbackLabel?: string;
}

export function getPriceLabel(props: IProps) {
    const {offerType, flatType, fallbackLabel, isHolidayLocation, isCondoHotel} = props;

    switch (offerType) {
        case OfferType.FLAT:
            if (isHolidayLocation || isCondoHotel || flatType === PropertyFlatType.APARTMENT) {
                return "Cena apartamentu";
            }
            if (flatType === PropertyFlatType.PENTHOUSE) {
                return "Cena penthousu";
            }
            return "Cena mieszkania";
        case OfferType.HOUSE:
            return "Cena domu";
        case OfferType.COMMERCIAL:
            return "Cena lokalu użytkowego";
        default:
            return fallbackLabel ?? "Cena nieruchomości";
    }
}
import {OfferType} from "../types/OfferType";
import {PropertyFlatType} from "../types/PropertyFlatType";

interface IProps {
    offerType?: OfferType;
    flatType?: PropertyFlatType;
    isHolidayLocation?: boolean;
    isCondoHotel?: boolean;
    fallbackLabel?: string;
}

export function getPriceLabel(props: IProps) {
    const {offerType, flatType, fallbackLabel, isHolidayLocation, isCondoHotel} = props;

    switch (offerType) {
        case OfferType.FLAT:
            if (isHolidayLocation || isCondoHotel || flatType === PropertyFlatType.APARTMENT) {
                return "Cena apartamentu";
            }
            if (flatType === PropertyFlatType.PENTHOUSE) {
                return "Cena penthousu";
            }
            return "Cena mieszkania";
        case OfferType.HOUSE:
            return "Cena domu";
        case OfferType.COMMERCIAL:
            return "Cena lokalu użytkowego";
        default:
            return fallbackLabel ?? "Cena nieruchomości";
    }
}
